import { render } from "./App.vue?vue&type=template&id=580ba587"
const script = {}

import "./App.vue?vue&type=style&index=0&id=580ba587&lang=css"
script.render = render

export default script